<template>
  <v-main>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-col>
          <h1 class="ml-n1 mb-n2 mt-n4">{{$t("Vehicles")}}</h1>
        </v-col>

        <v-flex xs12>
          <v-layout row wrap>
            <v-text-field class="ml-2 mr-2"
              v-model="searchText"
              append-icon="mdi-magnify"
              :label="$t('Search')"
              solo
              hide-details
              shrink
            ></v-text-field>
            <v-checkbox
              class="mt-3 ml-2 mr-2"
              :label="ct.Show_inactive"
              v-model="showInactive"
              :color="'primary'"
            ></v-checkbox>
            <v-flex grow></v-flex>
            <v-flex grow></v-flex>
            <v-flex grow></v-flex>
            <v-flex shrink>
              <v-select class="mt-n1 ml-3 mr-2" :items="facilitiesDisplay" v-model="facilityDisplay" @change="facilityChanged" :label="$t('Facility')"></v-select>
            </v-flex>
          </v-layout>

          <v-layout>
          <v-btn :loading="loading" class="ml-2 mr-2" color="primary" @click="loadVehicles">
            <v-icon left>search</v-icon>
            {{ $t('Search') }}
          </v-btn>
          <v-btn class="ml-2 mr-2" to="asphalt-delivery-vehicles/create" color="primary">
            <v-icon left>add</v-icon>
            {{$t("New")}}
          </v-btn>
          <v-btn
            class="ml-2 mr-2"
            :loading="submitting"
            @click="confirmDialog = true"
            v-if="this.isAdmin"
            >
            <v-icon left>update</v-icon>
            {{"Create all Vehicle Users"}}
          </v-btn>
          </v-layout>
        </v-flex>

        <v-progress-linear class="mt-2" v-if="loading" :indeterminate="true"></v-progress-linear>

        <v-flex v-else xs12>
          <v-data-table
            :headers="headers"
            :items="vehicles.filter(item => (showInactive || item.DeletedDate === null))"
            class="elevation-1 mt-2"
            item-key="Id"
            show-expand
            v-if="vehicles.filter(item => (showInactive || item.DeletedDate === null)).length > 0"
          >
            <template v-slot:[`item.UpdatedDate`]="{ item }">
              {{ formatDate(item.UpdatedDate) }}
            </template>
            <template v-slot:[`item.CreatedDate`]="{ item }">
              {{ formatDate(item.CreatedDate) }}
            </template>
            <template v-slot:[`item.DeletedDate`]="{ item }">
              {{ formatDate(item.DeletedDate) }}
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-btn color="primary" :to="{name: 'editAsphalt-delivery-vehicles', params: {id: item.Id, facilityNo: item.Facility, no: item.No}}">
                  <v-icon left>edit</v-icon>
                  {{$t("Edit")}}
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>

        <v-dialog
          v-model="confirmDialog"
          max-width="400">
          <v-card>
            <v-card-title class="headline">{{"Create all Vehicle Users"}}</v-card-title>
            <v-card-text>
              {{"Are you sure?"}}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="success" @click="confirmDialog = false; createVehicleUsers();">
                {{"Yes"}}
              </v-btn>
              <v-btn
                color="primary" @click="confirmDialog = false">
                {{"No"}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import ct from '@/core/mixins/common-translations'
import filters from '@/core/mixins/common-filters'
import formatDate from '@/core/mixins/formatDate'
import * as LocalStorage from '@/core/local-storage'
import { loadFacilities } from '@/core/archive'
import * as DateUtil from '@/core/date'
import { loadVehicles, saveVehiclesAndUsers } from '@/modules/asphalt-delivery/asphalt-delivery'
import { user } from '@/core/security'
import _ from 'lodash' // clone

export default {
  mixins: [ct, filters, formatDate],

  data () {
    return {
      loading: false,
      showInactive: false,
      vehicles: [],
      facilityNo: null,
      facilities: null,
      facilitiesDescription: [],
      facilityDescription: '',
      useFacilityDescription: false,
      facilityDisplay: '',
      facilitiesDisplay: [],
      search: '',
      confirmDialog: false,
      submitting: false,
      isAdmin: false,
      searchText: ''
    }
  },

  computed: {
    headers () {
      const res = [
        {
          text: this.$t('Facility'),
          value: 'Facility'
        },
        {
          text: this.$t('No.'),
          value: 'No'
        },
        {
          text: this.$t('VehicleLicensePlateNo'),
          value: 'LicensePlateNo'
        },
        {
          text: this.$t('Name'),
          value: 'Name'
        },
        {
          text: this.$t('Email'),
          value: 'Email'
        },
        {
          text: this.$t('Updated'),
          value: 'UpdatedDate'
        },
        {
          text: this.$t('Inactive'),
          value: 'DeletedDate'
        }
      ]

      return res
    }
  },

  methods: {

    async facilityChanged () {
      if (this.useFacilityDescription) {
        var facilityDisplay = this.facilitiesDisplay.find(f => f.value === this.facilityDisplay)
        if (facilityDisplay != null) {
          this.facilityNo = facilityDisplay.item.No
        }
      } else {
        this.facilityNo = this.facilityDisplay
      }
      if (this.facilityNo != null) LocalStorage.save('facilityNo', this.facilityNo)
    },

    createVehicleUsers () {
      this.submitting = true
      this.vehicles.forEach(vehicle => {
        // Save Vehicle User ONLY for active vehicles with LicensePlate length >= 5 and last 5 chars is a number
        if (!vehicle.DeletedDate && vehicle.LicensePlateNo && vehicle.LicensePlateNo.length >= 5 && !isNaN(vehicle.LicensePlateNo.substr(-5))) this.saveVehicleUser(vehicle)
      })
    },

    async saveVehicleUser (vehicle) {
      const res = await saveVehiclesAndUsers({
        Id: vehicle.Id,
        No: vehicle.No,
        LicensePlateNo: vehicle.LicensePlateNo,
        Facility: vehicle.Facility,
        Name: vehicle.Name,
        DeletedDate: vehicle.DeletedDate,
        UpdatedDate: DateUtil.getRealDate(Date.now()),
        Details: vehicle.Details
      })
      if (!res.failed) this.$root.$message.showSuccess('Vehicle User' + ': ' + vehicle.LicensePlateNo + ' Saved')
      else this.$root.$message.showError('Vehicle User' + ': ' + vehicle.LicensePlateNo + ' Save Failed')
    },

    async loadVehicles () {
      this.loading = true
      const res = await loadVehicles({ facility: this.facilityNo, searchText: this.searchText, loadDeleted: true })
      if (!res.failed) {
        this.vehicles = res.data.map(obj => ({ ...obj, Email: this.getValueFromArray(this.getItemFromArray(res.data, obj.Id, 'Details'), 'Comment2') }))
      }
      this.loading = false
      this.$forceUpdate()
      this.submitting = false
    },

    getItemFromArray (array, findId, findPropertyName) {
      var result = null
      if (Array.isArray(array) && array.length) {
        // array exists and is not empty
        var found = array.find(o => o.Id === findId)
        if (found) {
          // item exists
          result = found[findPropertyName]
          // if property does not exist we return null
          if (result === undefined) result = null
        }
      }
      return result
    },

    getValueFromArray (array, findName) {
      var result = null
      if (Array.isArray(array) && array.length) {
        // array exists and is not empty
        var found = array.find(o => o.Name === findName)
        if (found) {
          // item exists
          result = found.Value
          // if property does not exist we return null
          if (result === undefined) result = null
        }
      }
      return result
    }
  },

  async mounted () {
    var noValue = user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
    if (noValue) {
      this.useFacilityDescription = false
    } else {
      this.useFacilityDescription = user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
    }
    this.isAdmin = user.token.User.includes('Admin')
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    const facilitiesRes = await loadFacilities()
    const facilitiesResDescription = _.cloneDeep(facilitiesRes)
    if (!facilitiesRes.failed) {
      // MITH special: Let user select no facilities (by selecting facility '' ie. show vehicles from all facilities.)
      if (!facilitiesRes.data.includes('')) facilitiesRes.data.unshift({ No: '', Name: '' })
      this.facilities = facilitiesRes.data.map(item => {
        return {
          text: item.No,
          value: item.No,
          item: item
        }
      })
      this.facilitiesDisplay = this.facilities
      if (this.useFacilityDescription) {
      // const facilitiesRes2 = await Archive.loadFacilities()
        var d = facilitiesResDescription.data
        if (!d.includes('')) d.unshift({ No: '', Description: '' })
        this.facilitiesDescription = d.map(item => {
          return {
            text: item.Description,
            value: item.Description,
            item: item
          }
        })

        this.facilitiesDisplay = this.facilitiesDescription
      }
    }

    const storedFacilityNo = '' + LocalStorage.load('facilityNo')

    if (storedFacilityNo && this.facilities.some(e => e.item.No === storedFacilityNo)) {
      this.facilityNo = storedFacilityNo
      this.facilityDisplay = this.facilityNo
    } else {
      this.facilityNo = null
      LocalStorage.remove('facilityNo')
    }
    if (this.useFacilityDescription) {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilitiesDescription.find(f => f.item.No === this.facilityNo).value
    } else {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilities.find(f => f.item.No === this.facilityNo).value
    }
  }
}
</script>
